const es = {
  100000001:'Información clave',
  100000002:'Nombre del token',
  100000003:'Creador de la copia',
  100000004:'Tiempo de creación de la instancia',
  100000005:'Información básica  ',
  100000006:'Cadena de bloques/protocolo asociado  ',
  100000007:'Dirección del contrato inteligente  ',
  100000008:'Fecha de emisión',
  100000009:'Suministro total',
  100000010:'Suministro de circulación',
  100000011:'Valor de mercado',
  100000012:'Información',
  100000013:'Información de redes sociales',
  100000014:'Página web',
  100000015:'Libro blanco',
  100000016:'Explorador de blockchain  ',
  100000017:'Calificación del proyecto',
  100000018:'Ranking',
  100000019:'Top',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'Hora de actualización',
  100000027:'Puntuación de seguridad  ',
  100000028:'Puntuación de seguridad del contrato  ',
  100000029:'Estadísticas de proyectos de riesgo  ',
  100000030:'Detalles del código del contrato  ',
  100000031:'Impuesto de compra  ',
  100000032:'Impuesto de venta  ',
  100000033:'Es un honeypot  ',
  100000034:'Se puede volver a mint  ',
  100000035:'Existe una lista negra  ',
  100000036:'Existe una lista blanca  ',
  100000037:'Es anti-ballenas  ',
  100000038:'Se puede cambiar la tasa impositiva  ',
  100000039:'Es de código abierto  ',
  100000040:'Existen titulares ocultos  ',
  100000041:'Se puede autodestruir  ',
  100000042:'Es un contrato proxy  ',
  100000043:'Se puede cambiar el saldo  ',
  100000044:'Se pueden ejecutar llamadas externas  ',
  100000045:'Se puede recuperar la propiedad  ',
  100000046:'Existe un período de enfriamiento para las transacciones  ',
  100000047:'Se pueden pausar las transferencias  ',
  100000048:'La propiedad no ha sido renunciada  ',
  100000049:'Es anti-ballenas ajustable  ',
  100000050:'Demasiados decimales  ',
  100000051:'Métodos públicos de Mint y Burn  ',
  100000052:'Quemar tokens actualiza el suministro total  ',
  100000053:'Quemar tokens actualiza el saldo    ',
  100000054:'Una transferencia a sí mismo aumenta el saldo    ',
  100000055:'Transferir más tokens de los que hay en el saldo será inválido  ',
  100000056:'El saldo no se actualiza durante la transferencia  ',
  100000057:'Se consumirá el saldo del receptor  ',
  100000058:'Llamar a TransferFrom superando el saldo fallará  ',
  100000059:'El método BurnFrom actualiza el suministro total  ',
  100000060:'Detectar el impuesto de compra del token. Más del 5% se considera una tasa de impuesto alta.',
  100000061:'Detectar el impuesto de venta del token. Más del 5% se considera una tasa de impuesto alta.',
  100000062:'Comprobar si el token es una estafa de tipo honeypot.',
  100000063:'Comprobar si se pueden acuñar más tokens.',
  100000064:'Comprobar si el token tiene una lista negra que puede restringir a los usuarios de intercambiar o transferir tokens.',
  100000065:'Comprobar si el token tiene una lista blanca que permite a las direcciones evitar cualquier restricción.',
  100000066:'Comprobar si el token tiene mecanismos anti ballena.',
  100000067:'Comprobar si el token tiene un impuesto y si este impuesto puede ser modificado por roles privilegiados.',
  100000068:'Comprobar si el token ha sido verificado en un explorador de blockchain.',
  100000069:'Comprobar si el token tiene un propietario oculto que puede manipular el contrato, incluso si la propiedad parece haber sido renunciada.',
  100000070:'Comprobar si el token puede autodestruirse.',
  100000071:'Comprobar si el token es un contrato proxy que delega llamadas de funciones a un contrato de implementación.',
  100000072:'Comprobar si el saldo del token puede ser modificado por roles privilegiados.',
  100000073:'Comprobar si el token llama a contratos externos.',
  100000074:'Comprobar si el token tiene una puerta trasera para recuperar la propiedad.',
  100000075:'Comprobar si el token tiene un mecanismo de enfriamiento de transferencias.',
  100000076:'Comprobar si el comercio del token puede ser pausado por roles privilegiados.',
  100000077:'Comprobar si se ha renunciado al privilegio del propietario.',
  100000078:'Comprobar si los mecanismos anti ballena del token pueden ser modificados por roles privilegiados.',
  100000079:'Comprobar si el valor devuelto por la función decimals() es mayor o igual a 5.',
  100000080:'Comprobar si llamar a las funciones mint() y burn() como usuarios aleatorios provocará un revert.',
  100000081:'Comprobar si llamar a la función burn() actualizará correctamente el totalSupply.',
  100000082:"Comprobar si llamar a la función burnFrom() actualizará correctamente la asignación.",
  100000083:'Comprobar si llamar a la función transfer() con el receptor igual al remitente de la transacción aumentará el saldo del remitente.',
  100000084:'Comprobar si llamar a la función transfer() con una cantidad mayor que el saldo fallará.',
  100000085:"Comprobar si la asignación del gastador se actualiza adecuadamente después de llamar a la función transferFrom().",
  100000086:"Comprobar si llamar a la función transferFrom() utilizará el saldo del gastador.",
  100000087:"Compruebe si la asignación se actualiza correctamente después de llamar a transferFrom(), o si la transacción se revierte si la cantidad es inválida.",
  100000088:"Compruebe si llamar a la función burnFrom() actualizará correctamente el totalSupply.",
  100000089:'Comprobar si existe autoridad para acuñar.',
  100000090:'Comprobar si existe autoridad para congelar.',
  100000091:'Revisar si los metadatos pueden ser cambiados.',
  100000092:'Crítico',
  100000093:'Mayor',
  100000094:'Medio',
  100000095:'Menor',
  100000096:'Informativo',
  100000097:'Se ha renunciado al permiso de mint  ',
  100000098:'Se ha renunciado al permiso de congelación  ',
  100000099:'Se pueden cambiar los metadatos del token  ',

  100000100:'Su informe anual se está generando…',
  100000101:'Bienvenido a',
  100000102:'Su revisión de 2024',
  100000103:'Soy su guía personal',
  100000104:'aquí para guiarlo a través de las huellas de su viaje de 2024',
  100000105:'Abrir informe',
  100000106:'Hace {num} días, las ruedas del destino comenzaron a girar.',
  100000107:'{userName} Nuestra historia comienza desde aquí',
  100000108:'Juntos, corrimos hacia un sueño compartido.',
  100000109:'Estrellas de Inversión',
  100000110:'Descripción general anual de la billetera: tasa de rendimiento total',
  100000111:'Estás por delante del <em class="normal bold" style="color: #2AFF0A;">{percentage}</em> de los usuarios',
  100000112:'En el último año, experimentamos el <em class="normal bold" style="color: #FFF;">FOMO</em> que trajeron las inscripciones y disfrutamos de la alegría del <em class="normal bold" style="color: #FFF;">meme auge</em>. Ahora, viajemos juntos a tus recuerdos.',
  100000113:'Estrella Trader',
  100000114:'Transacciones acumuladas en 2024 (veces)',
  100000115:'Monto acumulado de la transacción ($)',
  100000116:'Superó al <em class="normal bold" style="color: #FFC72B;">{percentage}%</em> de los usuarios.',
  100000117:'Esto no es solo un logro numérico, sino también una insignia de su visión y sabiduría.',
  100000118:'Cada operación es un paso hacia la Web 3.0.',
  100000119:'Estrella en ascenso',
  100000120:'La mayor caída de Bitcoin en 2024 alcanzó el <em class="normal">34%</em>. Las correcciones del mercado son la norma y el rendimiento de su inversión es solo una fase: ¡hay un gran potencial por delante!',
  100000121:'Inversor constante',
  100000122:'Cada observación y espera fue para prepararse para un momento más preciso. Esperamos ver sus milagros de inversión y ganancias en 2025.',
  100000123:'El token más negociado en 2024',
  100000124:'Lo que retienes, te devuelve el eco.',
  100000125:'Tu concentración y esfuerzo ya se han reflejado en los resultados de tus operaciones.',
  100000126:'Rendimiento de Bitcoin en SuperEx en 2024',
  100000127:'Tu cambio de precio de Bitcoin en 2024',
  100000128:'¡Felicitaciones por hacer crecer tus activos! Mantén el impulso en el próximo año.',
  100000129:'En 2024, no tenía Bitcoin.',
  100000130:'Inversor destacado',
  100000131:'Inversor constante',
  100000132:'Inversor en aprendizaje',
  100000133:'Tus datos de operaciones en el mercado principal',
  100000134:'ganancias($)',
  100000135:'Rendimiento anualizado (%)',
  100000136:'Ranking de ganancias (%)',
  100000137:'Tus datos de operaciones contractuales',
  100000138:'Tu estrategia de operaciones muestra tu sabiduría: ¡gracias por elegir asociarte con nosotros!',
  100000139:'Zarpando hacia el futuro',
  100000140:'¡No solo has estado al tanto de las tendencias, sino que eres un pionero de las mismas! ¡Has lanzado monedas en la zona libre <em class="normal bold" style="color: #FFF;">{num1}</em> veces y has negociado <em class="normal bold" style="color: #FFF;">{num2}</em> veces! ¡Tú, que amas los productos innovadores, eres el verdadero aventurero!',
  100000141:'Superestrella social',
  100000142:'Gracias por traer <em class="normal bold" style="color: #FFF;">{num}</em> nuevos usuarios a nuestra plataforma. Tus referencias han impulsado nuestro crecimiento. Esperamos que más personas con ideas afines se unan a nosotros en el viaje de la Web3.0.',
  100000143:'Estrella social en ascenso',
  100000144:'Los <em class="normal bold" style="color: #FFF;">{num}</em> usuarios de SuperEx han ganado hasta un 40 % en comisiones de transacciones al invitar a amigos. Si no pudiste participar en 2024, no te preocupes: aprovecha la oportunidad en 2025.',
  100000145:'¡Comparte tus aspectos destacados anuales con tu comunidad, anima a más personas a unirse a nosotros y desbloquea recompensas exclusivas mientras exploran juntos el mundo de las criptomonedas!',
  100000146:'¡Invita a un amigo a obtener una recompensa por valor de 10 USDT!',
  100000147:'Compartir Informe',
  100000148:'Ver de nuevo',
  100000149:'En 2024, eras conocido en SuperEx como',
  100000150:'Superaste a los usuarios de la plataforma:',
  100000151:'Mercado principal Comercio spot Rendimiento Anual',
  100000152:'Contrato Rendimiento Anual',
  100000153:'¡Este año soy una leyenda de la inversión!',
  100000154:'Código de referencia: {InviteCode}',
  100000155:'SuperEx.com - Intercambio de criptomonedas  Web3.0',
  100000156:'¡Ganancias constantes, fortaleza revelada!',
  100000157:'¡Este año se ganó experiencia, el año que viene será aún mejor!',
  100000158:'¿Sabía que?',
  100000159:'La zona de libre comercio de SuperEx es la plataforma de negociación de Meme coins más popular y prometedora del mundo.',
  100000160:'2024, superex añade <em class="normal bold" style="color: #FFF;">{num}</em> nuevos usuarios, como nueva familia',
  100000161:'Tu revisión de 2024 y el viaje hacia ganancias mil veces en 2025 está a punto de comenzar.',
  100000162:'Esta es una carta de un miembro senior de la familia Superex, que registra sus buenas noticias para 2024.',
  100000163:'@to*** compró 1 BTC con 1 USDT, con un rendimiento de hasta <em class="normal bold" style="color: #FFF;font-size:0.7rem">9,958,800%</em>.',
  100000164:'@1o*** obtuvo 1 ETH por 1 USDT, con un rendimiento de hasta <em class="normal bold" style="color: #FFF;font-size:0.7rem">487,000%</em>.',
  100000165:'@we*** obtuvo 1 iPhone 15 por 1 USDT, con un rendimiento <em class="normal bold" style="color: #FFF;font-size:0.7rem">92,800%</em>.',
  100000166:'Hay más cosas emocionantes…',
  100000167:'Pequeñas inversiones, grandes retornos y un juego en constante evolución hacen que cada participación esté llena de sorpresas.',
  100000168:'Spot, contrato, gestión de patrimonio…',
  100000169:'La carta es larga, sigamos leyendo',
  100000170:'Emisión acumulativa de tokens iniciales <span class="inline-block relative bold" style="color: #FFFFFF;font-size:1rem">150+</span>, SuperEx seguirá esforzándose por crear más oportunidades para los usuarios.',
  100000171:'Resumen anual de la billetera Tasa de ganancias acumuladas de la cuenta',
  100000172:'Resumen de la billetera Cuenta Monto de Ganancias y Pérdidas Anuales <em class="normal bold {classNum}">{num}</em>',
  100000173:'Estás por delante del <em class="normal bold" style="color: #FFF;font-size:1rem">{percentage}%</em> de los usuarios. Tu sabiduría en estrategias de inversión es impresionante.',
  100000174:'2025-SuperEx',
  100000175:'Camino hacia la riqueza',
  100000176:'Abre cuando estés listo',
  100000177:'¡Hola! Soy un nuevo amigo de SuperEx.',
  100000178:'Únete a SuperEx y explora posibilidades infinitas. Regístrate para obtener beneficios para nuevos usuarios.',
  100000179:'Usuario @vb*** participa en el trading del mercado spot principal, con una tasa de retorno acumulado de casi el <em class="normal bold" style="color: #FFF;font-size:0.7rem">10,400%</em> para $ATOM.',
  100000180:'Usuario @xi*** participa en el comercio del mercado principal al contado, el rendimiento acumulado de $PIPE es de casi <em class="normal bold" style="color: #FFF;font-size:0.7rem">7,400%</em>.',
  100000181:'El usuario @09*** participa en la negociación principal de $ATH con un rendimiento acumulado cercano al <em class="normal bold" style="color: #FFF;font-size:0.7rem">3,500%</em>.',
  100000182:'¡Esperamos ser testigos de su primera transacción en el intercambio WEB3 y comenzar un capítulo emocionante!',
  100000183:'1usd, Super Start、 1000 + spot, palanca 150x, inscripción 1000x…',
  100000184:'¡Experimenta varios sectores de alto rendimiento!',
  100000185:'Las subidas y bajadas son temporales, pero la fe perdura.',
  100000186:'A través de la volatilidad, se atestigua el verdadero valor.',
  100000187:'Tu informe anual de 2024 aún no se ha generado. ¡Bienvenido a un nuevo año de viajes comerciales! Acumula más interacciones para desbloquear el resumen exclusivo del próximo año.',
  100000188:'¡La historia anual de criptomonedas de 2024 está esperando que la revises! ¡Revive los momentos más destacados de 2024 con SuperEx, ven y comparte tus momentos exclusivos! ',
  100000189:'¡La historia anual de criptomonedas de 2024 está esperando que la revises!',
  100000190: 'Abra la aplicación SuperEx para ver el "Informe anual"',
  100000191: '{year}año {month}mes {day}día (UTC)',
  100000192: 'Comprador',
  100000193: 'Código de pedido',
  100000194: 'Yo',
  100000195: 'Lista de participantes',
  100000196: 'Los artículos de moneda digital han sido emitidos. Por favor, contacte con el servicio al cliente para recibir artículos físicos',
  100000197: 'Compra Exitosa ',
  100000198: '{name}obtenido con éxito',
  100000199: 'Comprar',
  100000200: 'Todo Cargado',
  100000201: '¡Enhorabuena a {name} por ganar {shop}!',
  100000202: '¡El usuario {name} se unió a {shop} con éxito!'

}
export default es


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/es.js